<template>
  <div>
    <v-card
      tile
      elevation="0"
      color="transparent"
      class="d-flex align-center mb-5 px-2"
    >
      <div class="mr-2 text-h6">공지사항 (개발중)</div>
      <template v-if="routeName !== 'noticeWrite'">
        <v-btn to="/notice/write" fab small elevation="0" color="transparent">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    routeName() {
      return this.$route.name;
    },
    // title() {
    //   let title = "자료실";
    //   if (this.routeName === "dataWrite") {
    //     title = "자료 등록";
    //   }
    //   return title;
    // },
  },
};
</script>

<style></style>
